export default {
    outdoorsLocalizationContractors: [],
    outdoorsLocalizationContractorsLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        name: null
    }
}
